package ai.jessie.web.work

import ai.jessie.shared.work.WorkCalendarResponse

// Week-view period as entered: one offered date with a start and an end time of day.
data class WorkCalendarSelection(val date: String = "", val from: String = "", val to: String = "")

/**
 * BR-050, A4. Both times snap to five minutes and belong to the one selected date, so an end at or
 * before the start is a non-positive or date-crossing period and yields no duration. Only the
 * duration is kept: work entries store no start time (plan blocker B1).
 */
internal fun WorkCalendarSelection.snappedMinutes(): Int? {
    val start = minuteOfDay(from)
    val end = minuteOfDay(to)
    if (start == null || end == null) return null
    return (snapped(end) - snapped(start)).takeIf { it > 0 }
}

// UC-008 accepts work up to the organisation-local today; both dates are the server's.
internal fun WorkCalendarResponse.creatableDates() =
    days.map { it.date }.filter { it <= currentDate }

private fun minuteOfDay(value: String): Int? {
    val time = TIME_OF_DAY.matchEntire(value) ?: return null
    return time.groupValues[1].toInt() * MINUTES_PER_HOUR + time.groupValues[2].toInt()
}

private fun snapped(minutes: Int) = (minutes + SNAP_MINUTES / 2) / SNAP_MINUTES * SNAP_MINUTES

private val TIME_OF_DAY = Regex("([01]\\d|2[0-3]):([0-5]\\d)(?::[0-5]\\d(?:\\.\\d+)?)?")
private const val MINUTES_PER_HOUR = 60
internal const val SNAP_MINUTES = 5
